import React from 'react';
import { PatientContactsTable } from './PatientContactsTable';
import { NoItemsFound } from '~/shared/components/NoItemsFound';
import { getPatientContactsOptions } from '@generated';
import { useSuspenseQuery } from '@tanstack/react-query';
import { ContactFormModal } from './forms/ContactFormModal';

export function PatientContacts({ stayId }: { stayId: string }) {
	const { data: patientContacts } = useSuspenseQuery(getPatientContactsOptions(stayId));

	return (
		<NoItemsFound
			title="No contacts recorded"
			subtitle="Click the button below to add a contact"
			itemCount={patientContacts.contacts.length}
			renderModal={closeModal => <ContactFormModal stayId={stayId} closeModal={closeModal} />}
			renderTable={() => <PatientContactsTable rows={patientContacts.contacts} />}
		/>
	);
}
